import { Framework } from '@/framework/instance';
import { IDragData, IPoint } from '@/version-types';
import { getDragLayerState } from './states/drag-state';

export class DragLayerPlugin extends Framework {
    getUploadName() {
        return 'gs-stage-upload';
    }

    destroy() {
        getDragLayerState(this.framework.identity).setDragData(null);
    }

    setDragData(dragData: IDragData | null) {
        getDragLayerState(this.framework.identity).setDragData(dragData);
    }

    emitUploadFile(files: FileList, position: IPoint) {
        this.framework.events.emit(this.getUploadName(), files, position);
    }

    onUploadFile(fn: (files: FileList, position: IPoint) => void) {
        return this.framework.events.on(this.getUploadName(), fn);
    }

    offUploadFile(handle: number) {
        this.framework.events.off(handle);
    }
}
